/**
 * PIPELINE API — Wrapper dei REST pubblicati da `PipelinesResourceImpl`
 * (modulo crm-rest). I 5 metodi CRUD standard vengono da `createCrudApi`.
 *
 * Contratto backend (rest-openapi.yaml + PipelinesResourceImpl):
 *   - GET    /pipelines/{groupId}   (+ page, pageSize, sort, search) -> Page<Pipeline>
 *   - POST   /pipelines/{groupId}   PipelineInput                    -> Pipeline
 *   - GET    /pipeline/{pipelineId}                                  -> Pipeline
 *   - PATCH  /pipeline/{pipelineId} PipelineInput (aggregato)        -> Pipeline
 *   - DELETE /pipeline/{pipelineId}                                  -> 204
 *
 * Plurale `pipelines` per la collezione (list e create), singolare `pipeline`
 * per il singolo record: convenzione di tutto il CRM. La GET di lista ritorna
 * una `Page<T>` serializzata da Vulcan anche se l'OpenAPI dichiara `type: array`.
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudApi } from '../../store/createCrudApi';
import {
  pipelineFromDto,
  pipelineCreateToInput,
  pipelineUpdateToInput,
  type PipelineDto,
  type Pipeline,
} from './pipelineMappers';
import type {
  PipelineCreatePayload,
  PipelineUpdatePayload,
} from './pipelineTypes';

export const pipelineApi = createCrudApi<
  Pipeline,
  PipelineDto,
  PipelineCreatePayload,
  PipelineUpdatePayload,
  ServerListParams
>({
  collection: '/pipelines',
  single: '/pipeline',
  fromDto: pipelineFromDto,
  createToInput: pipelineCreateToInput,
  updateId: (p) => p.pipelineId,
  updateToInput: pipelineUpdateToInput,
});
